import { GlobalContextModel } from './globalcontext';
import { webapi } from 'ps-gui';

export async function initializeSession(token, options) {
	let globalContext = new GlobalContextModel();
	globalContext = await globalContext.setSessionToken(token, options);
	globalContext = await globalContext.checkLogoutImminent();
	return globalContext.apply();
}

export function setLoggedOut() {
	let globalContext = new GlobalContextModel();
	globalContext = globalContext.setLoggedOut();
	return globalContext.apply();
}

export function getLanguageId() {
	let globalContext = new GlobalContextModel();
	return globalContext.getLanguageId();
}

export async function logout() {
	await webapi.execute('/api/proc/api_user/logout');
	setLoggedOut();
}

export async function checkLogoutImminent() {
	let globalContext = new GlobalContextModel();
	globalContext = await globalContext.checkLogoutImminent();
	return globalContext.apply();
}

let cliTid = null;
export function checkLogoutImminentIn(seconds) {
	if (seconds > 300) {
		seconds = 300;
	}
	if (cliTid) {
		window.clearTimeout(cliTid);
	}
	cliTid = window.setTimeout(checkLogoutImminent, seconds * 1000);
}

export function setLogoutIn(seconds) {
	let globalContext = new GlobalContextModel();
	globalContext = globalContext.setLogoutIn(seconds);
	return globalContext.apply();
}

export function clearLogoutImminent() {
	let globalContext = new GlobalContextModel();
	globalContext = globalContext.clearLogoutImminent();
	return globalContext.apply();
}
